import {Component, OnInit} from '@angular/core';
import {ProjectsService} from "@components/projects/projects.service";
import {BackendResponse} from "@app/interfaces/backendResponse";
import {ToastrService} from "ngx-toastr";

@Component({
    selector: 'app-projects',
    templateUrl: './projects.component.html',
    styleUrls: ['./projects.component.css']
})
export class ProjectsComponent implements OnInit {

    loader = false;
    projects = [];

    userActivatedProjectId = '';


    constructor(
        private projectsService: ProjectsService,
        private toastr: ToastrService
    ) {
    }

    async ngOnInit() {
        this.loader = true;
        await this.getProjects();


        this.loader = false;
    }

    // all projects
    getProjects() {
        this.projects = [];
        return new Promise((resolve, reject) => {
            this.projectsService.getProjects().subscribe((responseData: BackendResponse) => {
                if (responseData.type == 'success') {
                    this.projects = responseData.data;
                    resolve();
                } else {
                    this.toastr.error('Došlo je do greške prilikom izvlačenja projekata.');
                    reject();
                }
            }, error => {
                reject(error);
            })


        });
    }

    activateProject(id) {
        this.userActivatedProjectId = id;
        this.projectsService.activateProject(id).subscribe((response: BackendResponse) => {
            if (response.type === 'error') {
                this.toastr.error('Došlo je do greške. Molimo Vas obratite se korisničkoj podršci.');
                this.userActivatedProjectId = '';

            } else if (response.type === 'success') {
                this.projectsService.userActiveProject.next(response.data);
            }

        });

    }

}

